import axios from 'axios';
import { ref } from 'vue-demi';

import { useApi } from '@/hooks/use_api';
import { User } from '@/models/user';

const user = ref<User>();

/**
 * ユーザー情報取得
 */
export function useUser() {
  const api = useApi();
  async function getUser() {
    const response = await api.getUsers().catch(error => {
      if (axios.isAxiosError(error) && !error.response) {
        // API の実行がキャンセルされたときに error_handler で握りつぶされる問題があるため別のエラーに変換する
        throw new Error('failed to getUser');
      }
      throw error;
    });
    user.value = response.dataJson;
  }

  return {
    user,
    getUser,
  };
}
